import type { TableEndpoint } from '@ipfabric/utils';
import {
  ApiTable,
  type ApiTableProps,
} from 'components/ApiTable/components/ApiTable';
import type { ComponentType } from 'react';

interface CreateConnectedApiTableArgs {
  tableEndpoint: TableEndpoint<any>;
}

export type ConnectedApiTableProps = Omit<ApiTableProps, 'endpoint'>;

export const createConnectedApiTable = (
  args: CreateConnectedApiTableArgs,
): ComponentType<ConnectedApiTableProps> => {
  const ConnectedApiTable: ComponentType<ConnectedApiTableProps> = (props) => (
    <ApiTable endpoint={args.tableEndpoint} {...props} />
  );
  ConnectedApiTable.displayName = `ConnectedApiTable[${args.tableEndpoint.id}]`;
  return ConnectedApiTable;
};
